import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '@/App';

import { logger } from '@/utils/logger';
import { CheckCircle, Mail } from 'lucide-react';
export default function Unsubscribe() {
  const { userId } = useParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleUnsubscribe = useCallback(async () => {
    try {
      await api.post(`/unsubscribe/${userId}`);
      setSuccess(true);
    } catch (err) {
      logger.error('Unsubscribe error:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    handleUnsubscribe();
  }, [handleUnsubscribe]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#FFFAF5' }}>
        <div className="text-xl" style={{ color: '#20212B' }}>Processing your request...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#FFFAF5' }}>
        <div className="max-w-md mx-auto bg-white rounded-2xl p-8 shadow-lg text-center">
          <div className="text-6xl mb-4">❌</div>
          <h1 className="text-2xl font-bold mb-4" style={{ color: '#20212B' }}>
            Something Went Wrong
          </h1>
          <p className="text-gray-600">
            We couldn't process your request. Please try again later or contact support.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#FFFAF5' }}>
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
          {/* Success Icon */}
          <div className="mb-6">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full" style={{ background: '#FED7A5' }}>
              <CheckCircle className="w-10 h-10" style={{ color: '#9E6752' }} />
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-3xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif', color: '#20212B' }}>
            Unsubscribed Successfully
          </h1>

          {/* Message */}
          <div className="mb-6">
            <Mail className="w-12 h-12 mx-auto mb-3" style={{ color: '#9E6752' }} />
            <p className="text-lg mb-2" style={{ color: '#534145' }}>
              Check your email inbox
            </p>
            <p className="text-sm" style={{ color: '#73766A' }}>
              We've sent you a confirmation email with details about your updated preferences.
            </p>
          </div>

          {/* Info Box */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left">
            <p className="text-sm" style={{ color: '#534145' }}>
              <strong>You've opted out of:</strong><br />
              • Marketing emails<br />
              • Promotional offers<br />
              <br />
              <strong>You'll still receive:</strong><br />
              • Occasion reminders (if enabled)<br />
              • Important account notifications
            </p>
          </div>

          {/* Fine Print */}
          <p className="text-xs" style={{ color: '#9CA3AF' }}>
            Changed your mind? You can manage your email preferences anytime from your account settings.
          </p>
        </div>
      </div>
    </div>
  );
}
